const PAY_ON_SHIP_DEFAULT_CONFIG = {
  PAY_ON_SHIP_REWARDS_POINTS: 3000,
  PAY_ON_SHIP_DEAL_BRANDS: ['amc', 'bombas', 'zws', 'vrbo', 'groupon', 'nike'],
};

export default PAY_ON_SHIP_DEFAULT_CONFIG;
